import OurServicesSimple from "../../Components/OurServicesSimple";
import OurServicesDetails from "../../Components/OurServicesDetails";
import PageLayout from "../../Components/Common/PageLayout";
import SEO from "../../Components/Common/SEO";
import "./style.scss";

const Services: React.FC = () => {
  return (
    <PageLayout className="Services">
      <SEO
        title="Our Services | Window & Gutter Cleaning"
        description="Explore our range of cleaning services including domestic and commercial window cleaning, conservatory roof cleaning, and gutter maintenance in the Farnham area."
        canonical="https://farnhamanddistrictwindowcleaning.uk/Services"
      />
      <div className="servicesContent">
        <OurServicesSimple order="odd" />
        <OurServicesDetails order="even" />
      </div>
    </PageLayout>
  );
};

export default Services;
